module.exports = __webpack_public_path__ + "static/media/Defi-para-1.c42d4f54.jpg";